export const intervalRefObj = {
  intervalId: null,
  requestsCount: 0,
  clearDirectoriesInterval: function () {
    clearInterval(this.intervalId);
  },

  refreshInterval: function () {
    if (this.requestsCount < 2) {
      this.clearDirectoriesInterval();
    }
  },

  checkForClearInterval: function (dataObj) {
    dataObj.forEach((item) => {
      if (!item.is_syncing_now) {
        this.clearDirectoriesInterval();
        this.requestsCount = 0;
      }
    });
  }
};